module.exports = __webpack_public_path__ + "static/1.1.E.4 FORNA PLAN DE SITUATIE-ce2f0bf4a794301aeb1df0db50e8ed0b.jpg";